const isPersisted = event => event.persisted;

const scrollToParamRegex = /&scrollTo=([^&#]+)/;

const removeScrollToFromQuery = href => {
  window.history.replaceState({}, "", href.replace(scrollToParamRegex, ""));
};

const scrollToElement = element => {
  if (!element) {
    return;
  }

  setTimeout(() => {
    // force scroll, since anchor for some reason not working
    element.scrollIntoView();
  }, 50);
};

const anchorToProduct = () => {
  if (!("onpagehide" in window)) {
    return;
  }

  window.addEventListener("pageshow", event => {
    if (isPersisted(event)) {
      return;
    }

    const match = window.location.href.match(scrollToParamRegex);
    if (match) {
      const [, scrollToElementId] = match;
      removeScrollToFromQuery(window.location.href);
      scrollToElement(document.getElementById(scrollToElementId));
    }
  });

  window.addEventListener("pagehide", event => {
    if (isPersisted(event)) {
      return;
    }

    window.scrollTo(0, 0);
  });
};

export default anchorToProduct;
